import { combineReducers } from 'redux';

import account from './account/reducers';
import authenticate from './authenticate/reducers';
import check from './check/reducers';
import confirmAccount from './confirmAccount/reducers';
import income from './income/reducers';
import incomeForm from './incomeForm/reducers';
import profile from './profile/reducers';
import registerAccount from './registerAccount/reducers';
import start from './start/reducers';
import tac from './tac/reducers';
import track from './track/reducers';
import flash from './flash/reducers';
import storage from './storage/reducers';
import counter from './counter/reducers';

export default combineReducers({
  account,
  authenticate,
  check,
  confirmAccount,
  income,
  incomeForm,
  profile,
  registerAccount,
  start,
  tac,
  track,
  flash,
  storage,
  counter,
});



// WEBPACK FOOTER //
// ./src/redux/reducers.js